import React from "react";
import { MdClose } from "react-icons/md"; // Close icon
import styles from "./css/Info.module.css";

const SwingHighLowInfo = ({ isOpen, toggleDrawer }) => {
  return (
    <div>
      {/* Collapsible Side Drawer */}
      <div className={`${styles.drawer} ${isOpen ? styles.open : ""}`}>
        <div className={styles.drawerHeader}>
          <MdClose className={styles.closeIcon} onClick={toggleDrawer} />
        </div>

        <div className={styles.infoItem}>
          <h4>What is a Swing High/Low?</h4>
          <p>
            A Swing High is a peak in price, surrounded by lower highs on either side. A Swing Low is a trough in price,
            surrounded by higher lows on either side. These points represent significant short-term reversals in market
            direction.
          </p>
          <p>
            <b>Why is it important to traders?</b> Swing highs and lows are critical for identifying:
          </p>
          <ul>
            <li>Key support and resistance levels.</li>
            <li>Market structure and trend direction.</li>
            <li>Potential areas for trade entries and exits.</li>
          </ul>
        </div>

        <div className={styles.infoItem}>
          <h4>1. Characteristics of Swing Highs</h4>
          <p>
            <b>Definition:</b> A Swing High forms when a price high is surrounded by two lower highs.<br />
            <b>Significance:</b> Swing highs act as resistance levels and indicate potential selling pressure.
          </p>
          <p>
            <b>Visual Identification:</b> Look for peaks on the chart where price fails to break higher and begins to
            decline.
          </p>
        </div>

        <div className={styles.infoItem}>
          <h4>2. Characteristics of Swing Lows</h4>
          <p>
            <b>Definition:</b> A Swing Low forms when a price low is surrounded by two higher lows.<br />
            <b>Significance:</b> Swing lows act as support levels and indicate potential buying pressure.
          </p>
          <p>
            <b>Visual Identification:</b> Look for troughs on the chart where price fails to drop lower and begins to
            rise.
          </p>
        </div>

        <div className={styles.infoItem}>
          <h4>3. Trading with Swing Highs and Lows</h4>
          <p>
            Traders use swing highs and lows to identify market structure and plan trades. Key strategies include:
          </p>
          <ul>
            <li>
              Using swing highs and lows to determine the current trend (e.g., higher highs and higher lows indicate an
              uptrend).
            </li>
            <li>Placing stop-loss orders just above swing highs or below swing lows to manage risk.</li>
            <li>
              Setting take-profit levels near the next swing high (in a long trade) or swing low (in a short trade).
            </li>
          </ul>
        </div>

        <div className={styles.infoItem}>
          <h4>4. Swing High/Low Breakouts</h4>
          <p>
            Breakouts occur when price moves beyond a swing high or low. These breakouts can signal a trend continuation
            or reversal.
          </p>
          <p>
            <b>Usage:</b> Traders often wait for confirmation after a breakout before entering a trade to avoid false
            breakouts.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SwingHighLowInfo;
